import React, { Component } from 'react';
import Breadcrumb from './Breadcrumb';
import ParkingContent from './ParkingContent'

class Parking extends Component {
    render() {
        return (
            <div>
                <div id="scrollUp" title="Scroll To Top">
                    <i className="fas fa-arrow-up" />
                </div>
                <div className="main">
                    <Breadcrumb/>
                    <ParkingContent />
                </div>
            </div>
        );
    }
}

export default Parking;